/*
 * Focus Trap helpers
 */

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, options = {}) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  first.focus(options);
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, wait) {
  let t = false;
  return (...args) => {
    if (!t) {
      fn.apply(this, args)
      t = true;
      setTimeout(() => t = false, wait)
    }
  }
}

/*
 * Woolman Common JS
 */

// Initialize window.Woolman object
if (typeof window.Woolman == 'undefined') {
  window.Woolman = {};
}
Woolman.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

// -------
// Load components / libraries
Woolman.init = function () {
  Woolman.ModalsAndDrawers.init();
  Woolman.Header.init();
  Woolman.DetailsAccordions.init();
  Woolman.Breadcrumbs.init();

  // Attach theme editor listeners
  if (!Shopify || !Shopify.designMode) return;

  let lastSelection = {
    sectionId: undefined,
    blockId: undefined
  };

  // Load is called when something is changed within section settings
  document.addEventListener('shopify:section:load', (evt) => {
    const sectionId = 'shopify-section-' + evt.detail.sectionId
    if (sectionId === Woolman.Header.cache.section.id) {
      Woolman.ModalsAndDrawers.init();
      Woolman.Header.init();
    }

    if (document.querySelector(`[data-modal][data-section-id="${evt.detail.sectionId}"]`)) {
      Woolman.ModalsAndDrawers.showModalOrDrawer(document.querySelector(`[data-modal][data-section-id="${evt.detail.sectionId}"]`).id);
    }

    console.log('shopify:section:load sectionId', evt.detail.sectionId)
    console.log('lastSelection', lastSelection)
  })

  document.addEventListener('shopify:block:select', (evt) => {
    const sectionId = 'shopify-section-' + evt.detail.sectionId
    const blocks = document.getElementById(sectionId).querySelectorAll('[data-shopify-editor-block]')
    const selectedBlock = [...blocks].find(x => JSON.parse(x.dataset.shopifyEditorBlock).id === evt.detail.blockId);
    if (sectionId === Woolman.Header.cache.section.id) {
      if (selectedBlock) {
        // Make sure menu is open
        Woolman.Header.cache.openButton.click();

        // Select menu item
        const accordion = selectedBlock.closest('[data-accordion-item]').querySelector('input');
        const label = selectedBlock.closest('[data-accordion-item]').querySelector('label');
        if (!accordion.checked) label.click();
      }
    } else if (sectionId.includes('modal') && document.getElementById(sectionId).querySelector('[data-modal]')) {
      if (selectedBlock) {
        Woolman.ModalsAndDrawers.showModalOrDrawer(document.getElementById(sectionId).querySelector('[data-modal]').id);
      }
    }

    lastSelection.sectionId = evt.detail.sectionId;
    lastSelection.blockId = evt.detail.blockId;
    console.log('shopify:block:select', evt.detail.sectionId, evt.detail.blockId)
    console.log('lastSelection', lastSelection)
  })

  document.addEventListener('shopify:section:unload', (evt) => {
    console.log('shopify:section:unload sectionId', evt.detail.sectionId)
  })

  document.addEventListener('shopify:section:select', (evt) => {
    console.log('shopify:section:select', evt.detail.sectionId)
    lastSelection = {
      sectionId: evt.detail.sectionId,
      blockId: evt.detail.blockId
    }

    if (evt.detail.sectionId.includes('modal') && document.querySelector(`[data-modal][data-section-id="${evt.detail.sectionId}"]`)) {
      Woolman.ModalsAndDrawers.showModalOrDrawer(document.querySelector(`[data-modal][data-section-id="${evt.detail.sectionId}"]`).id);
    }

    console.log('lastSelection', lastSelection)
  })

  document.addEventListener('shopify:section:deselect', (evt) => {
    console.log('shopify:section:deselect', evt.detail.sectionId)
    lastSelection = {
      sectionId: undefined,
      blockId: undefined
    }

    if (evt.detail.sectionId.includes('modal') && document.querySelector(`[data-modal][data-section-id="${evt.detail.sectionId}"]`)) {
      Woolman.ModalsAndDrawers.closeModalOrDrawer(document.querySelector(`[data-modal][data-section-id="${evt.detail.sectionId}"]`).id);
    }

    console.log('lastSelection', lastSelection)
  })
};

// -------
// Woolman Common JS - Utility library
Woolman.Utils = {
  debugMode: true,
  prepareQueryParams: () => {
    Shopify.queryParams = Shopify.queryParams || {};

    // Preserve existing query parameters
    if (location.search.length) {
      const params = location.search.substr(1).split('&');
      for (let i = 0; i < params.length; i++) {
        const keyValue = params[i].split('=');
        // Spaces are reverted back after the decode, since in component-facets.js we'll use URLSearchParams() method and we don't want to double decode the spaces
        if (keyValue.length) {
          Shopify.queryParams[decodeURIComponent(keyValue[0])] = decodeURIComponent(keyValue[1]).replaceAll('+', ' ');
        }
      }
    }

    return Shopify.queryParams;
  },
  formatMoney(cents, format) {
    const default_money_format = theme.settings.moneyFormat || '€{{amount}}';
    if (typeof cents == 'string') {
      cents = cents.replace('.', '');
    }
    if (window?.Shopify?.currency?.rate) {
      cents = cents * parseFloat(window.Shopify.currency.rate || 1.0);
    }

    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || default_money_format;

    function defaultOption(opt, def) {
      return typeof opt == 'undefined' ? def : opt;
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal = defaultOption(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents = parts[1] ? decimal + parts[1] : '';

      return dollars + cents;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  },
};

// -------
// Woolman Common JS - Breadcrumb helper
Woolman.Breadcrumbs = {
  selectors: {
    breadcrumb: '#uncomplicated-breadcrumbs',
    branch: '.breadcrumb__branch'
  },
  observer: null,
  observerTarget: null,
  isListening: false,
  isUpdating: false,
  restoreOnCollapsedClick: false,

  init: function () {
    if (!this.isListening) {
      document.addEventListener('woolman:resize', this.scheduleUpdate.bind(this));
      document.addEventListener('shopify:section:load', this.scheduleUpdate.bind(this));
      document.addEventListener('click', this.handleBranchClick.bind(this));
      this.isListening = true;
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', this.scheduleUpdate.bind(this), { once: true });
    } else {
      this.scheduleUpdate();
    }

    this.ensureObserver();
  },

  getObserverTarget: function () {
    const breadcrumb = this.getBreadcrumb();

    if (breadcrumb?.parentElement) {
      return breadcrumb.parentElement;
    }

    return document.getElementById('MainContent');
  },

  stopObserving: function () {
    if (!this.observer) return;

    this.observer.disconnect();
    this.observerTarget = null;
  },

  ensureObserver: function () {
    if (!this.observer) {
      this.observer = new MutationObserver((mutations) => {
        if (this.isUpdating) return;

        const hasBreadcrumbMutation = mutations.some((mutation) => {
          if (mutation.target instanceof Element && mutation.target.closest(this.selectors.breadcrumb)) {
            return true;
          }

          const touchedNodes = [...mutation.addedNodes, ...mutation.removedNodes];
          return touchedNodes.some((node) => {
            return node.nodeType === Node.ELEMENT_NODE && (
              node.id === 'uncomplicated-breadcrumbs' ||
              node.querySelector?.(this.selectors.breadcrumb)
            );
          });
        });

        if (hasBreadcrumbMutation) {
          this.ensureObserver();
          this.scheduleUpdate();
        }
      });
    }

    const nextTarget = this.getObserverTarget();
    if (!nextTarget) {
      this.stopObserving();
      return;
    }

    if (this.observerTarget === nextTarget) return;

    this.stopObserving();
    this.observer.observe(nextTarget, {
      childList: true,
      subtree: true
    });
    this.observerTarget = nextTarget;
  },

  scheduleUpdate: function () {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        this.update();
      });
    });
  },

  finishUpdate: function () {
    requestAnimationFrame(() => {
      this.isUpdating = false;
    });
  },

  getBreadcrumb: function () {
    return document.querySelector(this.selectors.breadcrumb);
  },

  isEnabled: function () {
    return theme?.settings?.enableBreadcrumbTruncation !== false;
  },

  isExpanded: function (breadcrumb) {
    return breadcrumb?.dataset.breadcrumbExpanded === 'true';
  },

  hasNavigableHref: function (branch) {
    return Boolean(branch?.getAttribute('href')?.trim());
  },

  shouldRestoreCollapsedBranch: function (branch) {
    return this.restoreOnCollapsedClick || !this.hasNavigableHref(branch);
  },

  getAccessibilityString: function (key, fallback) {
    return globalThis.accessibilityStrings?.[key] || fallback;
  },

  getFormattedAccessibilityString: function (key, fallback, replacements = {}) {
    return Object.entries(replacements).reduce((formattedString, [placeholder, value]) => {
      return formattedString.replace(`[${placeholder}]`, value);
    }, this.getAccessibilityString(key, fallback));
  },

  getInteriorBranches: function (breadcrumb) {
    const branches = [...breadcrumb.querySelectorAll(this.selectors.branch)];

    if (branches.length < 3) {
      return [];
    }

    return branches.slice(1, -1);
  },

  getCollapseCandidates: function (breadcrumb) {
    const interiorBranches = this.getInteriorBranches(breadcrumb);
    const firstIndex = Math.floor((interiorBranches.length - 1) / 2);
    const firstBranch = interiorBranches[firstIndex] || null;
    const secondBranch = interiorBranches[firstIndex + 1] || interiorBranches[firstIndex - 1] || null;

    return [firstBranch, secondBranch].filter(Boolean);
  },

  storeOriginalLabel: function (branch) {
    if (branch.dataset.breadcrumbOriginalLabel) return;

    branch.dataset.breadcrumbOriginalLabel = branch.textContent.trim();
    branch.dataset.breadcrumbOriginalAriaLabel = branch.getAttribute('aria-label') || '';
    branch.dataset.breadcrumbOriginalTitle = branch.getAttribute('title') || '';
  },

  restoreBranch: function (branch) {
    if (!branch?.dataset.breadcrumbOriginalLabel) return;

    branch.textContent = branch.dataset.breadcrumbOriginalLabel;
    delete branch.dataset.breadcrumbRestore;
    delete branch.dataset.breadcrumbCollapsed;
    delete branch.dataset.breadcrumbClickMode;

    if (branch.dataset.breadcrumbOriginalAriaLabel) {
      branch.setAttribute('aria-label', branch.dataset.breadcrumbOriginalAriaLabel);
    } else {
      branch.removeAttribute('aria-label');
    }

    if (branch.dataset.breadcrumbOriginalTitle) {
      branch.setAttribute('title', branch.dataset.breadcrumbOriginalTitle);
    } else {
      branch.removeAttribute('title');
    }
  },

  restoreManagedBranches: function (breadcrumb) {
    const branches = this.getInteriorBranches(breadcrumb);

    branches.forEach((branch) => {
      this.storeOriginalLabel(branch);
      this.restoreBranch(branch);
    });
  },

  collapseBranch: function (branch) {
    if (!branch?.dataset.breadcrumbOriginalLabel) return;

    const shouldRestore = this.shouldRestoreCollapsedBranch(branch);
    const originalLabel = branch.dataset.breadcrumbOriginalLabel;

    branch.textContent = '...';
    branch.dataset.breadcrumbCollapsed = 'true';
    branch.dataset.breadcrumbClickMode = shouldRestore ? 'restore' : 'link';

    if (shouldRestore) {
      branch.dataset.breadcrumbRestore = 'true';
      branch.setAttribute('aria-label', this.getFormattedAccessibilityString('showFullBreadcrumbPathFor', 'Show full breadcrumb path: [something]', { something: originalLabel }));
      branch.setAttribute('title', this.getAccessibilityString('showFullBreadcrumbPath', 'Show full breadcrumb path'));
      return;
    }

    delete branch.dataset.breadcrumbRestore;
    branch.setAttribute('aria-label', this.getFormattedAccessibilityString('navigateToSomething', 'Navigate to [something]', { something: originalLabel }));
    branch.setAttribute('title', this.getFormattedAccessibilityString('navigateToSomething', 'Navigate to [something]', { something: originalLabel }));
  },

  handleBranchClick: function (event) {
    const branch = event.target.closest(`${this.selectors.breadcrumb} ${this.selectors.branch}`);
    if (!branch?.dataset.breadcrumbCollapsed) return;
    if (branch.dataset.breadcrumbClickMode !== 'restore') return;

    event.preventDefault();

    const breadcrumb = branch.closest(this.selectors.breadcrumb);
    if (!breadcrumb) return;

    breadcrumb.dataset.breadcrumbExpanded = 'true';
    delete breadcrumb.dataset.breadcrumbTruncated;
    this.restoreManagedBranches(breadcrumb);
  },

  isOverflowing: function (breadcrumb) {
    const containerWidth = Math.floor(breadcrumb.parentElement.clientWidth);
    const breadcrumbWidth = Math.ceil(breadcrumb.scrollWidth);

    return Boolean(containerWidth && breadcrumbWidth > containerWidth);
  },

  update: function () {
    const breadcrumb = this.getBreadcrumb();
    this.ensureObserver();
    if (!breadcrumb?.parentElement) return;

    const collapseCandidates = this.getCollapseCandidates(breadcrumb);
    if (!collapseCandidates.length) return;

    this.isUpdating = true;
    this.restoreManagedBranches(breadcrumb);
    delete breadcrumb.dataset.breadcrumbTruncated;
    breadcrumb.dataset.breadcrumbTruncationEnabled = this.isEnabled() ? 'true' : 'false';

    if (!this.isEnabled()) {
      this.finishUpdate();
      return;
    }

    if (this.isExpanded(breadcrumb)) {
      this.finishUpdate();
      return;
    }

    // const isMobile = window.innerWidth < 768;

    if (this.isOverflowing(breadcrumb)) {
      collapseCandidates.some((branch) => {
        this.collapseBranch(branch);

        if (!this.isOverflowing(breadcrumb)) {
          breadcrumb.dataset.breadcrumbTruncated = 'true';
          return true;
        }

        return false;
      });

      if ([...breadcrumb.querySelectorAll(this.selectors.branch)].some((branch) => branch.dataset.breadcrumbCollapsed)) {
        breadcrumb.dataset.breadcrumbTruncated = 'true';
      }
    }

    this.finishUpdate();
  }
};

// -------
// Woolman Common JS - Header component
Woolman.Header = {
  selectors: {
    header: 'MainHeader',
    cartBlip: '.cart-blip'
  },
  cache: {
    header: undefined,
    cartBlip: undefined,
    section: undefined,
    openButton: undefined
  },

  init: function () {
    this.cache.header = document.getElementById(this.selectors.header);
    this.cache.cartBlip = this.cache.header.querySelector(this.selectors.cartBlip);
    this.cache.section = this.cache.header.closest('.shopify-section');
    this.cache.openButton = this.cache.header.querySelector('[href="#drawer-menu"]')

    // Update cart blip when product is added to cart.
    document.addEventListener('ajaxProduct:added', this.updateCartBlip.bind(this))
    document.addEventListener('cart:update', this.updateCartBlip.bind(this));

    if (this.cache.header.dataset.stickyBehavior === 'none') return;
    this.initStickyBehavior(this.cache.header.dataset.stickyBehavior)
  },

  initStickyBehavior(behaviorType) {
    const stickyConfig = {
      headerHeight: this.cache.header.clientHeight,
      behavior: behaviorType
    }

    document.documentElement.classList.add('sticky-header-initialized', `sticky-header-${behaviorType}`);
    document.documentElement.style.setProperty('--sticky-header-margin-top', `${stickyConfig.headerHeight}px`);

    if (behaviorType === 'scroll' || behaviorType === 'fixed') {
      // Show on scroll fixed header
      let prevScroll = window.scrollY || document.documentElement.scrollTop;
      let curScroll;
      let direction = 0;
      let prevDirection = 0;

      /*
      ** Find the direction of scroll
      ** 0 - initial, 1 - up, 2 - down
      */

      const toggleStickyHeader = (direction, curScroll) => {
        if ((direction === 1) || curScroll < stickyConfig.headerHeight) {
          document.documentElement.classList.remove('sticky-header-hide')
        } else if (direction === 2 && curScroll > stickyConfig.headerHeight) {
          document.documentElement.classList.add('sticky-header-hide')
        }

        prevDirection = direction;
      }

      const handleScroll = throttle(() => {
        curScroll = window.scrollY || document.documentElement.scrollTop;

        // Show the sticky header when scrolled past threshold
        if (curScroll >= 300) {
          document.documentElement.classList.add('sticky-header-show')
        } else {
          document.documentElement.classList.remove('sticky-header-show');
        }

        // Reset classes when at the top of the page
        if (curScroll === 0) {
          document.documentElement.classList.remove('sticky-header-show', 'sticky-header-hide');
          return;
        }

        // Determine scroll direction
        if (curScroll > prevScroll) {
          direction = 2; // user scrolling down
        } else {
          direction = 1; // user scrolling up
        }

        // Toggle header visibility based on scroll direction and behavior type
        if (direction !== prevDirection && behaviorType === 'scroll') {
          toggleStickyHeader(direction, curScroll);
        } else if (behaviorType === 'scroll' && direction === 2 && curScroll >= 900) {
          // Hide header when scrolling down and past the threshold
          toggleStickyHeader(direction, curScroll);
        }

        prevScroll = curScroll;
      }, 50);

      window.addEventListener('scroll', handleScroll);
    }
  },

  async updateCartBlip(e) {
    const cartItemCount = e.detail && e.detail.cart && e.detail.cart.item_count || await (async function () {
      const res = await fetch('/cart.json');
      const cart = await res.json();
      return cart.item_count;
    })();

    this.cache.cartBlip.textContent = cartItemCount || 0;
    if (cartItemCount && cartItemCount == 0) {
      this.cache.cartBlip.setAttribute('hidden', true);
      this.cache.cartBlip.closest('.header-item__link').classList.remove('has-blip-visible');
    } else {
      this.cache.cartBlip.removeAttribute('hidden')
      this.cache.cartBlip.closest('.header-item__link').classList.add('has-blip-visible');
    }

    // Update drawer cart amount at the same time (if present)
    const total_in_drawer = document.querySelector('[data-cart-title-item-count]');
    if (total_in_drawer) {
      total_in_drawer.textContent = `(${cartItemCount})`;
    }

    // Update notification cart amount at the same time (if present)
    const total_in_notification = document.querySelector('#cart-notification-link .cart-total');
    if (total_in_notification) {
      total_in_notification.textContent = cartItemCount;
    }
  }
};

// -------
// Woolman Common JS - Modals & drawers library
// Drawer cart ID has been changed from drawer-cart to CartDrawer for wishlist app because Hulk Wishlist requires it.

Woolman.ModalsAndDrawers = {
  settings: {
    selectors: {
      modalLink: 'a[href*="#modal"]:not(.quick-buy_link)',
      drawerLink: 'a[href*="#drawer"]',
      cartDrawerLink: 'a[href="#CartDrawer"]',
    },
  },
  focusTraps: {},
  init: function () {
    // Init open event listeners
    document.querySelectorAll(this.settings.selectors.modalLink).forEach((modalLink) => {
      modalLink.addEventListener('click', (event) => {
        event.preventDefault();
        const targetId = event.currentTarget.getAttribute('href').substring(1).split('?')[0];
        const slideIndex = event.currentTarget.getAttribute('href').substring(1).split('?slide=')[1];
        const scrollToId = event.currentTarget.getAttribute('href').substring(1).split('?scroll=')[1];
        this.showModalOrDrawer(targetId, parseInt(slideIndex), scrollToId, null, event.pointerType);
      });
    });

    document.querySelectorAll(this.settings.selectors.drawerLink).forEach((drawerLink) => {
      drawerLink.addEventListener('click', (event) => {
        event.preventDefault();
        const targetId = event.currentTarget.getAttribute('href').substring(1).split('?')[0];
        this.showModalOrDrawer(targetId, null, null, null, event.pointerType);
      });
    });

    document
      .querySelectorAll(this.settings.selectors.cartDrawerLink)
      .forEach((drawerLink) => {
        drawerLink.addEventListener("click", (event) => {
          event.preventDefault();
          const targetId = event.currentTarget
            .getAttribute("href")
            .substring(1)
            .split("?")[0];
          this.showModalOrDrawer(targetId, null, null, null, event.pointerType);
        });
      });

    // Init close event listeners
    const closeBtns = document.querySelectorAll('[data-close]');
    if (closeBtns) {
      closeBtns.forEach((closeBtn) => {
        closeBtn.addEventListener('click', this.closeModalOrDrawerOrDrawerFromEvent.bind(this));
      });
    }

    const overlays = document.querySelectorAll('[data-overlay]');
    if (overlays) {
      overlays.forEach((overlay) => {
        overlay.addEventListener('click', this.closeModalOrDrawerOrDrawerFromEvent.bind(this));
      });
    }

    // Escape to close all
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' || event.keyCode === 27) {
        document.querySelectorAll('.drawer').forEach((drawer) => {
          drawer.classList.remove('is-open');
        });
        document.querySelectorAll('.modal').forEach((modal) => {
          modal.classList.remove('is-open');

          // Return focus to the element that opened the modal
          const modalCloseButton = modal.querySelector('[data-modal-close]');
          if (modalCloseButton) {
            const modalOpener = document.getElementById(modalCloseButton.getAttribute('href').replace('#', ''));
            if (modalOpener) {
              modalOpener.focus();
            }
          }
        });
        document.querySelectorAll('.header-dropdown').forEach((headerDropdown) => {
          headerDropdown.removeAttribute('open');
        });
        document.body.classList.remove('overflow-hidden');
      }
    });
  },
  /**
   * Closes all open drawers
   */
  closeAllDrawers: function () {
    document.querySelectorAll('.drawer.is-open').forEach((drawer) => {
      drawer.classList.remove('is-open');
    });
  },
  /**
   *
   * @param {string} targetId - ID of modal or drawer element, e.g. modal-geo, drawer-menu
   * @param {int} slideIndex - Index of a Gridy Slider slide inside the opened modal - (sliding motion)
   * @param {string} scrollToId - ID of a Gridy Slider slide inside the opened modal - (no motion)
   * @param {HTMLElement} drawerFocusTarget - First child element in drawer menu to focus on when drawer is opened
   * @param {string} pointerType - Click event pointer type (mouse, touch, pen) - used to determine if focus should be visible
   * Traps focus to modal and disables body scrolling.
   */
  showModalOrDrawer: function (targetId, slideIndex, scrollToId, drawerFocusTarget, pointerType) {
    const targetElement = document.getElementById(targetId);
    if (!targetElement && Woolman.Utils.debugMode) {
      console.warn('No modal/drawer element specified');
    }
    if (!targetElement) {
      return;
    }

    if (targetElement.classList.contains('is-open')) return;

    // If opening a drawer, close all other drawers first
    if (targetElement.classList.contains('drawer')) {
      this.closeAllDrawers();
    }

    targetElement.classList.add('initialized', 'is-open');
    document.body.classList.add('overflow-hidden');
    const options = { focusVisible: pointerType === "" };

    // Dispatch custom event when modal or drawer is opened
    document.dispatchEvent(new CustomEvent('modal:opened', {
      detail: { modalId: targetId }
    }));

    setTimeout(() => {
      trapFocus(targetElement, options);

      // Focus on drawerSearchInput if it exists
      const drawerSearchInput = targetElement.querySelector('#drawerSearchInput');
      if (drawerSearchInput) {
        drawerSearchInput.focus(options);
      }

      if (drawerFocusTarget) {
        drawerFocusTarget.focus(options);
      }
    }, 600);

    if (slideIndex) {
      setTimeout(() => {
        const gridySlider = targetElement.querySelector('gridy-slider');
        gridySlider.scrollToSlide(slideIndex - 1);
      }, 600);
    } else if (scrollToId) {
      const scrollToElement = document.getElementById(scrollToId),
        modal_dialog = targetElement.querySelector('.gridy-track');

      modal_dialog.scrollTo({
        top: scrollToElement.offsetTop,
        left: scrollToElement.offsetLeft,
        behavior: "instant"
      });
    }
  },
  closeModalOrDrawer: function (targetId) {
    const targetElement = document.getElementById(targetId);
    if (targetElement) {
      targetElement.classList.remove('is-open');
    }
    // Only remove overflow-hidden if no drawers or modals are open
    const hasOpenDrawers = document.querySelectorAll('.drawer.is-open').length > 0;
    const hasOpenModals = document.querySelectorAll('.modal.is-open').length > 0;
    if (!hasOpenDrawers && !hasOpenModals) {
      document.body.classList.remove('overflow-hidden');
    }
  },
  closeModalOrDrawerOrDrawerFromEvent: function (event) {
    event.preventDefault();
    removeTrapFocus();
    const parentElement = event.currentTarget.closest('[data-parent]');
    if (parentElement) {
      parentElement.classList.remove('is-open');
    }
    // Only remove overflow-hidden if no drawers or modals are open
    const hasOpenDrawers = document.querySelectorAll('.drawer.is-open').length > 0;
    const hasOpenModals = document.querySelectorAll('.modal.is-open').length > 0;
    if (!hasOpenDrawers && !hasOpenModals) {
      document.body.classList.remove('overflow-hidden');
    }
  }
};

/**
 * Allow us to trigger something when window is actually resized.
 */
let woolman_window_size = window.innerWidth;
window.addEventListener(
  'resize',
  debounce(() => {
    if (window.innerWidth == woolman_window_size) {
      return;
    }
    woolman_window_size = window.innerWidth;
    document.dispatchEvent(new CustomEvent('woolman:resize'));
  }),
  250
);

/**
 * Animated details element
 */
class Accordion {
  constructor(el) {
    if (el.hasAttribute('data-no-accordion-logic')) {
      return;
    }
    this.el = el;
    this.summary = el.querySelector('summary');
    this.content = el.querySelector('.content');

    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.summary.addEventListener('click', (e) => this.onClick(e));
    this.toggleByViewport();
    document.addEventListener('woolman:resize', this.toggleByViewport.bind(this));
  }

  onClick(e) {
    e.preventDefault();
    this.el.style.overflow = 'hidden';
    if (this.isClosing || !this.el.open) {
      this.open();
    } else if (this.isExpanding || this.el.open) {
      this.shrink();
    }
  }

  shrink() {
    this.isClosing = true;

    const startHeight = `${this.el.offsetHeight}px`;
    const endHeight = `${this.summary.offsetHeight}px`;

    if (this.animation) {
      this.animation.cancel();
    }

    this.animation = this.el.animate({
      height: [startHeight, endHeight]
    }, {
      duration: 400,
      easing: 'ease-in-out'
    });

    this.animation.onfinish = () => this.onAnimationFinish(false);
    this.animation.oncancel = () => this.isClosing = false;
  }

  open() {
    this.el.style.height = `${this.el.offsetHeight}px`;
    this.el.open = true;
    window.requestAnimationFrame(() => this.expand());
  }

  expand() {
    this.isExpanding = true;
    const startHeight = `${this.el.offsetHeight}px`;
    const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;

    if (this.animation) {
      this.animation.cancel();
    }

    this.animation = this.el.animate({
      height: [startHeight, endHeight]
    }, {
      duration: 400,
      easing: 'ease-out'
    });
    this.animation.onfinish = () => this.onAnimationFinish(true);
    this.animation.oncancel = () => this.isExpanding = false;
  }

  onAnimationFinish(open) {
    this.el.open = open;
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.el.style.height = this.el.style.overflow = '';
  }

  toggleByViewport() {
    let mobileClose = this.el.dataset.mobileClose != undefined ? JSON.parse(this.el.dataset.mobileClose) : false;
    let desktopOpen = this.el.dataset.desktopOpen != undefined ? JSON.parse(this.el.dataset.desktopOpen) : false;

    if (woolman_window_size >= 768 && desktopOpen) {
      this.el.open = true;
    } else if (mobileClose) {
      this.el.open = false;
    }
  }
};

Woolman.DetailsAccordions = {
  init: function () {
    document.querySelectorAll('details').forEach((el) => {
      new Accordion(el);
    });
  }
};

Woolman.init();

class ModalDrawerButton extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('button');
    this.button.addEventListener('click', this.onClick.bind(this));
    this.button.addEventListener('focus', this.onFocus.bind(this));
  }

  onClick(event) {
    event.preventDefault();
    const targetId = this.button.dataset.open.split('?')[0];
    const slideIndex = this.button.dataset.open.split('?slide=')[1];
    const scrollToId = this.button.dataset.open.split('?scroll=')[1];
    Woolman.ModalsAndDrawers.showModalOrDrawer(targetId, parseInt(slideIndex), scrollToId, null, event.pointerType);
  }

  onFocus() {
    const scrollToId = this.button.dataset.open.split('?scroll=')[1];
    const mediaSlider = this.closest('gridy-slider');
    if (scrollToId && mediaSlider) {
      mediaSlider.scrollToSlideByID(scrollToId);
    }

    // Set the close button to focus on the button that opened the modal
    const targetId = this.button.dataset.open.split('?')[0];
    const modal = document.getElementById(targetId);
    const modalCloseButton = modal.querySelector('[data-modal-close]');
    if (modalCloseButton) {
      modalCloseButton.setAttribute('href', `#${this.button.id}`); // This is used in the global escape key event listener to return focus to the button that opened the modal
      modalCloseButton.addEventListener('click', (event) => {
        // Focus visible only when using keyboard
        const options = { focusVisible: event.pointerType === "" };
        this.button.focus(options);
      });
    }
  }
}
customElements.define('modal-drawer-button', ModalDrawerButton);

class HeaderDropdown extends HTMLElement {
  constructor() {
    super();
    this.details = this.querySelector('details');
    this.summary = this.querySelector('summary');
    this.dropdown = this.details.querySelector('[data-dropdown-panel]');
    this.header = this.closest('header'); // Define the header element once
    this.timer = null;
    this.openTimer = null;

    this.summary.addEventListener('mouseenter', this.startOpenTimer.bind(this));
    this.details.addEventListener('mouseenter', this.clearCloseTimer.bind(this));
    this.details.addEventListener('mouseleave', this.startCloseTimer.bind(this));
    this.details.addEventListener('mouseleave', this.clearOpenTimer.bind(this));
    this.summary.addEventListener('keydown', this.handleKeydown.bind(this));
    this.dropdown.addEventListener('keydown', this.keyboardCloseDropdown.bind(this));
  }

  openDropdown() {
    this.closeOtherDropdowns();
    this.details.open = true;
    if (this.header) {
      this.header.classList.add('sub-menu-open');
    }
  }

  closeOtherDropdowns() {
    if (this.header) {
      const otherDropdowns = this.header.querySelectorAll('header-dropdown details[open]');
      otherDropdowns.forEach(dropdown => {
        if (dropdown !== this.details) {
          dropdown.open = false;
          const parentDropdown = dropdown.closest('header-dropdown');
          if (parentDropdown && typeof parentDropdown.clearCloseTimer === 'function') {
            parentDropdown.clearCloseTimer();
          }
        }
      });
    }
  }

  keyboardCloseDropdown(event) {
    if (event.key === 'Escape') {
      this.details.open = false;
      if (this.header) {
        this.header.classList.remove('sub-menu-open');
      }
      this.summary.focus();
    }
  }

  startOpenTimer() {
    const ms = 250;
    this.openTimer = setTimeout(() => {
      this.openDropdown();
    }, ms);
  }

  clearOpenTimer() {
    if (this.openTimer) {
      clearTimeout(this.openTimer);
      this.openTimer = null;
    }
  }

  startCloseTimer() {
    const ms = 250;
    const debugMs = 100_000;
    this.timer = setTimeout(() => {
      this.details.open = false;
      if (this.header) {
        this.header.classList.remove('sub-menu-open');
      }
    }, ms);
  }

  clearCloseTimer() {
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
  }

  handleKeydown(event) {
    if (event.key === 'Enter' || event.key === ' ') {
      // Prevent default behavior to avoid double toggling
      event.preventDefault();

      // If the target is a link, navigate to the link
      if (event.target.getAttribute('href') !== null) {
        window.location = event.target.getAttribute('href');
        return;
      }

      // If the target is a summary, toggle the dropdown
      if (!this.details.open) {
        this.openDropdown();
      } else {
        this.details.open = false;
        if (this.header) {
          this.header.classList.remove('sub-menu-open');
        }
      }
    }
  }
}
customElements.define('header-dropdown', HeaderDropdown);

class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="locale_code"], input[name="country_code"]')
    };

    this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    this.elements.input.value = event.currentTarget.dataset.value;

    // Filter params fix, replace "%2C" with ","
    let return_to_value = form.querySelector('[name="return_to"]').value;
    let indexOfFilters = return_to_value.indexOf("?filter");
    if (indexOfFilters !== -1) {
      let substringAfterFilters = return_to_value.substring(indexOfFilters);
      let replacedSubstring = substringAfterFilters.replace(/%2C/g, ",");
      form.querySelector('[name="return_to"]').value = return_to_value.substring(0, indexOfFilters) + replacedSubstring;
    }

    if (form) form.submit();
  }
}

customElements.define('localization-form', LocalizationForm);

// Custom element that enhances HTML Video Element functionality.
// Usage: <video is="superpowered-video">
class SuperPoweredVideo extends HTMLElement {
  constructor() {
    super();

    this.video = this.querySelector('video') || this.querySelector('iframe');
    this.container = this.closest('.video-container') || null;

    if (this.container) this.attachClickListener(this.closest('.video-container'));

    // check if video is iframe and has a src and that src is youtube
    if (this.video.nodeName === 'IFRAME' && this.video.src && this.video.src.includes('youtube') && !this.container) {
      this.video.addEventListener('load', this.onVideoLoad.bind(this));
    }

    // When video is out of viewport pause it. This is to prevent videos from playing in the background.
    // If video is in viewport play it.
    // Use: Intersection Observer API
    const autoplay = this.dataset.autoplay || false;
    if (!autoplay || this.container) return;

    const videoType = this.video.nodeName === 'VIDEO' ? 'video' : 'iframe';
    const videoHost = this.video.nodeName === 'VIDEO' ? 'shopify' : (this.video.src.includes('youtube') ? 'youtube' : 'vimeo');

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          if (videoType == 'video') {
            this.video.play();
          } else if (videoHost == 'youtube') {
            this.video.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
          } else if (videoHost == 'vimeo') {
            this.video.contentWindow.postMessage('{"method":"play"}', '*');
          }
        } else {
          if (videoType == 'video') {
            this.video.pause()
          } else if (videoHost == 'youtube') {
            this.video.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
          } else if (videoHost == 'vimeo') {
            this.video.contentWindow.postMessage('{"method":"pause"}', '*');
          }
        }
      });
    }, { threshold: 0.5 });

    observer.observe(this.video);
  }

  attachClickListener(videoContainer) {
    if (!videoContainer) return;
    videoContainer.addEventListener('click', (e) => {
      if (this.video.paused) {
        this.video.play();
      } else {
        this.video.pause();
      }
    });

    this.video.onplay = () => {
      videoContainer.querySelector('button').hidden = true;
    }

    this.video.onpause = () => {
      videoContainer.querySelector('button').hidden = false;
    }
  }

  onVideoLoad() {
    // force youtube to play on mobile
    this.video.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
  }
}
customElements.define('superpowered-video', SuperPoweredVideo);

// Gridy Slider - a custom Woolman built slider.
// Usage: <gridy-slider>
class GridySlider extends HTMLElement {
  constructor() {
    super();

    const nostoParent = this.closest('nosto-section-campaign[data-slider-id]');
    if (nostoParent) {
      this.id = nostoParent.dataset.sliderId;
    }

    this.track = this.querySelector('.gridy-track');
    this.slides = this.querySelectorAll('.gridy-track > *');
    this.arrows = this.querySelector('.gridy-arrows')
      || document.querySelector(`.gridy-arrows[data-slider-target="${this.id}"]`);
    const child_count = this.track.childElementCount;

    const data_ipr_desktop = parseInt(this.dataset.iprDesktop, 10) || 1;
    const data_ipr_tablet = parseInt(this.dataset.iprTablet, 10) || data_ipr_desktop;
    const data_ipr_mobile = parseInt(this.dataset.iprMobile, 10) || 1;
    const data_init_scroll_to = this.dataset.initScrollTo;
    const data_autoplay = this.dataset.autoplay != undefined ? JSON.parse(this.dataset.autoplay) : false;
    const data_autoplay_delay = parseInt(this.dataset.autoplayDelay, 10) || 5000;
    const data_is_thumbnails_slider = this.dataset.thumbnailsFor != undefined ? true : false;
    const data_indicator = this.dataset.indicator != undefined ? JSON.parse(this.dataset.indicator) : false;
    const data_sliding_behavior = this.dataset.slidingBehavior;
    const data_thumbnail_slider = document.getElementById(`thumbnail-${this.id}`);
    const data_track_overflow_visible = this.dataset.overflowVisible != undefined ? true : false;
    const data_desktop_enabled = this.dataset.desktopEnabled != undefined ? JSON.parse(this.dataset.desktopEnabled) : false

    this.config = {
      slide_count: child_count,
      current_slide: 0,
      active_slide_offset: 0, // used for thubnails slider

      ipr_desktop: data_ipr_desktop,
      ipr_tablet: data_ipr_tablet,
      ipr_mobile: data_ipr_mobile,
      breakpoint_tablet: 768,
      breakpoint_desktop: 1024,

      arrows: true,
      autoplay: data_autoplay || false,
      autoplay_delay: data_autoplay_delay, // in ms
      timer: null,

      // thumbnails related
      is_thumbnails_slider: data_is_thumbnails_slider,
      thumbnails_for: undefined,
      thumbnail_slider: data_thumbnail_slider,

      indicator: data_indicator,
      track_overflow_visible: data_track_overflow_visible,
      sliding_behavior: data_sliding_behavior || 'all'
    }

    // SCROLL ON INIT (with variant URL)
    if (data_init_scroll_to != undefined) {
      this.scrollToSlideByID(data_init_scroll_to);
    }

    this.updateArrowVisibility();

    // ARROWS INIT
    if (this.config.arrows && this.arrows) {
      this.buttons = this.arrows.querySelectorAll('[data-gridy-arrow]');
      this.buttons.forEach((arrowButton) => {
        arrowButton.addEventListener('click', this.onArrowClick.bind(this));
      });
    }

    // AUTOPLAY INIT
    if (this.config.autoplay) {
      this.autoplayGridy();

      // Always pause on hover
      this.addEventListener('mouseenter', this.clearAutoplayTimer);
      this.addEventListener('mouseleave', this.autoplayGridy);

      // Pause for touch devices
      this.addEventListener('touchenter', this.clearAutoplayTimer);
      this.addEventListener('touchleave', this.autoplayGridy);
    }

    // THUMBNAILS INIT
    if (this.config.is_thumbnails_slider) {
      this.config.active_slide_offset = 2,
        this.config.thumbnails_for = document.getElementById(this.dataset.thumbnailsFor);
      this.thumbnail = this.querySelectorAll('[data-thumbnail-btn]');
      this.thumbnail.forEach((thumbnail) => {
        thumbnail.addEventListener('click', this.onThumbnailClick.bind(this));
      });
    }

    // CURRENT SLIDE INDICATORS INIT
    if (this.config.indicator) {
      this.indicator_dots = this.querySelectorAll('[data-indicator-dot]');
      this.indicator_current = this.querySelector('[data-indicator-current]');
    }

    // SCROLL LISTENER (for setting active slide after normal scroll)
    if (!this.config.is_thumbnails_slider) {
      let scrollTimeout;
      this.track.addEventListener('scroll', function () {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(this.afterScrollStops.bind(this), 200);
      }.bind(this));
    }
  }

  afterScrollStops() {
    let slideInView = this.firstSlideInView();
    this.config.current_slide = slideInView;
    this.setActiveSlide(this.slides[slideInView + this.config.active_slide_offset]);

    // SYNC BACK TO THUMBNAILS SLIDER
    if (this.config.thumbnail_slider) {
      this.config.thumbnail_slider.scrollToSlide(slideInView);
    }
  }

  autoplayGridy() {
    this.config.timer = setInterval(this.scrollByIPR.bind(this), this.config.autoplay_delay, 'next');
  }

  clearAutoplayTimer() {
    clearInterval(this.config.timer);
    this.config.timer = null;
  }

  onThumbnailClick(event) {
    event.preventDefault();
    this.config.current_slide = Array.from(event.currentTarget.parentNode.children).indexOf(event.currentTarget);
    this.config.thumbnails_for.scrollToSlideByID(event.currentTarget.dataset.itemId);
    this.scrollToSlide(this.config.current_slide);
  }

  onArrowClick(event) {
    this.scrollByIPR(event.currentTarget.dataset.direction);
  }

  scrollByIPR(direction) {
    let currentIPR = this.getCurrentIPR(),
      slideMultiplier = this.config.sliding_behavior == 'all' ? currentIPR : 1,
      newCurrentSlide = this.config.current_slide,
      lastToShow = this.config.slide_count - currentIPR;

    if (direction === 'next') {
      newCurrentSlide = (newCurrentSlide + slideMultiplier);

      // Handle exceptions (Correct flow on next)
      if (this.config.current_slide >= lastToShow) {
        newCurrentSlide = 0; // Loop to start if all shown
      }
    } else if (direction === 'prev') {
      newCurrentSlide = (newCurrentSlide - slideMultiplier);

      // Handle exceptions
      if (this.config.current_slide > 0 && newCurrentSlide < 0) {
        newCurrentSlide = 0; // Must scroll to first item if before looping to the end
      } else if (newCurrentSlide < 0) {
        newCurrentSlide = lastToShow; // Loop to end slide past the first item
      }
    }

    this.config.current_slide = newCurrentSlide;
    this.scrollToSlide(newCurrentSlide);
  }

  scrollToSlide(newPosition) {
    // Needs to use scrollTo() instead of scrollIntoView()
    // since the later affects window scroll and thus cannot
    // be used with autoplay sliders.

    if (isNaN(newPosition)) {
      return;
    }

    // Can show different active slide compared to scrollTo slide for example in thumbnails slider
    let slidePosWithOffset = newPosition - this.config.active_slide_offset,
      newScrollToSlidePos = slidePosWithOffset > 0 ? slidePosWithOffset : 0;

    const slideInNewScrollToPos = this.slides[newScrollToSlidePos];

    let scrollToLeft = slideInNewScrollToPos.offsetLeft,
      scrollToTop = slideInNewScrollToPos.offsetTop;

    // If the track overflow is visible the scroll offset much include the left padding of the track
    // That is calculated with the first child offsetLeft
    if (this.config.track_overflow_visible) {
      scrollToLeft = this.slides[newScrollToSlidePos].offsetLeft - this.slides[0].offsetLeft;
    }

    this.track.scrollTo({
      left: scrollToLeft,
      top: scrollToTop,
      behavior: "smooth",
    });

    this.slides.forEach((item) => { item.classList.remove('active') });
    this.slides[newPosition].classList.add('active');
  }

  scrollToSlideByID(slideID) {
    // Second scrollTo method used with slideID
    // Used through thumbnails and variant change events

    const theSlide = document.getElementById(slideID);
    if (!theSlide || !theSlide.parentNode) return;

    const newPosition = Array.from(theSlide.parentNode.children).indexOf(theSlide);
    if (newPosition < 0) return;

    this.scrollToSlide(newPosition);
  }

  setActiveSlide(slide) {
    this.slides.forEach((item) => { item.classList.remove('active') });
    slide.classList.add('active');

    if (this.config.indicator) {
      this.indicator_current.textContent = this.config.current_slide + 1;
      this.indicator_dots.forEach((dot) => { dot.classList.remove('active') });
      this.indicator_dots[this.config.current_slide].classList.add('active');
    }
  }

  // Utility, returns items per row value according to current viewport size
  getCurrentIPR() {
    let currentIPR = this.config.ipr_mobile;
    if (woolman_window_size >= this.config.breakpoint_desktop) {
      currentIPR = this.config.ipr_desktop;
    } else if (woolman_window_size >= this.config.breakpoint_tablet) {
      currentIPR = this.config.ipr_tablet;
    }
    return currentIPR;
  }

  // Utility, returns the position of the first slide in view (1..n)
  firstSlideInView() {
    let loopIndex = 0;
    for (const slide of this.slides) {
      if (this.isSlideInView(slide)) {
        return loopIndex;
      }
      ++loopIndex;
    }

    // If visibility check fails return the last known current_slide
    return this.config.current_slide;
  }

  // Element visibility check
  isSlideInView(slide) {
    const containerBounds = this.track.getBoundingClientRect();
    const slideBounds = slide.getBoundingClientRect();

    const isSlideVisible =
      Math.round(slideBounds.top) >= Math.floor(containerBounds.top) &&
      Math.floor(slideBounds.bottom) <= Math.round(containerBounds.bottom) &&
      Math.round(slideBounds.left) >= Math.floor(containerBounds.left) &&
      Math.floor(slideBounds.right) <= Math.round(containerBounds.right);

    return isSlideVisible;
  }

  updateArrowVisibility() {
    if (!this.arrows) return;
    const count = this.config.slide_count;
    const mobileEnabled = this.dataset.mobileEnabled === 'true';
    const tabletEnabled = this.dataset.tabletEnabled === 'true';
    const desktopEnabled = this.dataset.desktopEnabled === 'true';

    this.arrows.classList.toggle('sm-down-hide', !mobileEnabled || count <= this.config.ipr_mobile);
    this.arrows.classList.toggle('sm-to-md-hide', !tabletEnabled || count <= this.config.ipr_tablet);
    this.arrows.classList.toggle('md-hide', !desktopEnabled || count <= this.config.ipr_desktop);
  }

  update() {
    this.slides = this.querySelectorAll('.gridy-track > *');
    this.config.slide_count = this.slides.length;
    this.updateArrowVisibility();
    this.track.scrollTo({
      left: 0,
      top: 0,
      behavior: "instant"
    });
    this.scrollToSlide(this.config.current_slide);
  }

}
customElements.define('gridy-slider', GridySlider);

Woolman.QuantityLimits = {
  getVariantRules(variant, inventoryData) {
    const rules = {
      min: 1,
      max: null,
      disabled: false
    };

    if (!variant || variant.available === false) {
      rules.disabled = true;
      return rules;
    }

    if (variant.inventory_management !== 'shopify' || !inventoryData || inventoryData.policy === 'continue') {
      return rules;
    }

    const quantity = Number(inventoryData.quantity);
    if (Number.isFinite(quantity) && quantity > 0) {
      rules.max = quantity;
    }

    return rules;
  },

  applyRulesToInput(input, rules = {}) {
    if (!input) return false;

    const nextMin = Number.isFinite(Number(rules.min)) ? Number(rules.min) : Number(input.min || 1);
    const nextMax = Number.isFinite(Number(rules.max)) && Number(rules.max) > 0 ? Number(rules.max) : null;
    const nextDisabled = Boolean(rules.disabled);

    input.min = `${nextMin}`;
    if (nextMax !== null) {
      input.max = `${nextMax}`;
    } else {
      input.removeAttribute('max');
    }
    input.disabled = nextDisabled;

    let nextValue = Number(input.value);
    if (!Number.isFinite(nextValue) || nextValue < nextMin || nextDisabled) {
      nextValue = nextMin;
    }
    if (nextMax !== null && nextValue > nextMax) {
      nextValue = nextMax;
    }

    const valueChanged = `${nextValue}` !== input.value;
    if (valueChanged) {
      input.value = `${nextValue}`;
    }

    const quantityInput = input.closest('quantity-input');
    if (quantityInput && typeof quantityInput.refresh === 'function') {
      quantityInput.refresh({ dispatchChange: valueChanged });
    } else if (valueChanged) {
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    return valueChanged;
  }
};

// QuantityInput for + and - button functionality
// Used in: cart items, upsell items
class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.minusButton = this.querySelector('button[name="minus"]');
    this.plusButton = this.querySelector('button[name="plus"]');
    this.changeEvent = new Event('change', { bubbles: true });

    if (!this.input) return;

    this.refresh();
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.input.addEventListener('input', this.updateButtonStates.bind(this));
    this.querySelectorAll('button').forEach((button) => button.addEventListener('click', this.onButtonClick.bind(this)));
  }

  onButtonClick(event) {
    event.preventDefault();
    if (!this.input || this.input.disabled) return;

    const previousValue = this.input.value;

    event.currentTarget.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    this.refresh();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  onInputChange() {
    this.refresh();
  }

  getCurrentValue() {
    if (!this.input || this.input.value === '') return null;

    const value = Number(this.input.value);
    return Number.isFinite(value) ? value : null;
  }

  getMaxValue() {
    if (!this.input || this.input.max === '') return null;

    const max = Number(this.input.max);
    return Number.isFinite(max) ? max : null;
  }

  syncValueWithinBounds() {
    if (!this.input || this.input.value === '') return false;

    const min = Number(this.input.min || 0);
    const max = this.getMaxValue();
    const value = this.getCurrentValue();
    if (value === null) return false;

    let nextValue = value;
    if (nextValue < min) {
      nextValue = min;
    }
    if (max !== null && nextValue > max) {
      nextValue = max;
    }

    if (`${nextValue}` === this.input.value) return false;

    this.input.value = `${nextValue}`;
    return true;
  }

  updateButtonStates() {
    if (!this.input) return;

    const min = Number(this.input.min || 0);
    const max = this.getMaxValue();
    const value = this.getCurrentValue();
    const isDisabled = this.input.disabled;

    if (this.minusButton) {
      this.minusButton.disabled = isDisabled || (value !== null && value <= min);
    }
    if (this.plusButton) {
      this.plusButton.disabled = isDisabled || (value !== null && max !== null && value >= max);
    }
  }

  refresh({ dispatchChange = false } = {}) {
    const valueChanged = this.syncValueWithinBounds();
    this.updateButtonStates();

    if (dispatchChange && valueChanged) {
      this.input.dispatchEvent(this.changeEvent);
    }

    return valueChanged;
  }

  updateMinusButtonState() {
    if (!this.minusButton || !this.input) return;

    const value = this.getCurrentValue();
    const min = Number(this.input.min || 0);
    this.minusButton.disabled = value <= min;
  }
}
customElements.define('quantity-input', QuantityInput);

